import * as React from 'react';

const ContentfulLineBreak: React.FunctionComponent<{}> = () => (
  <div className="w-100" />
);

export default ContentfulLineBreak;
